import { OutlinedInput } from '@material-ui/core';
import { FormControl, InputLabel } from '@mui/material';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import extendCoolingPeriod from '../../../../api/Purchasers/extendCoolingPeriod.api';
import { closeModal, openModal } from '../../../../redux/modals/action';
import CustomButton from '../../../layout/customButton/CustomButton';
import Modal from '../../../layout/modal/Modal';
import styles from './ExtendCoolingModal.module.scss';

const ExtendCoolingModal = ({
	showModal,
	closeModal,
	endCoolingPeriod,
	leadId,
	openModal,
}) => {
	const [durationAdd, setDurationAdd] = useState(0);

	const handlePlus = () => {
		if (validateDurationValue(durationAdd)) {
			// clearPriceAddSubtractError();
			setDurationAdd(Number(durationAdd) + 1);
		}
		//  else {
		// 	setPriceAddSubtractError(true);
		// 	setPriceAddSubtractErrMsg('Invalid number.');
		// }
	};

	const handleSubtract = () => {
		if (validateDurationValue(durationAdd) && durationAdd >= 1) {
			// clearPriceAddSubtractError();
			setDurationAdd(Number(durationAdd) - 1);
		}
		// else {
		// 	setPriceAddSubtractError(true);
		// 	setPriceAddSubtractErrMsg('Invalid number.');
		// }
	};

	const handleChange = (e) => {
		if (e.target.name === 'duration') {
			setDurationAdd(e.target.value);
			// clearPriceAddSubtractError();
		}
	};

	const validateDurationValue = (number) => {
		if (number === '') {
			return false;
		} else {
			if (!isNaN(number)) {
				return true;
			} else {
				return false;
			}
		}
	};

	const handleUpdate = () => {
		console.log('handleUpdate durationAdd', durationAdd);
		extendCoolingPeriod(endCoolingPeriod, leadId, durationAdd);
		closeModal('extendCoolingPeriod');
		openModal('clientDetails');
	};

	return (
		<div className={styles.extendCoolingModal}>
			<Modal
				show={showModal}
				close={() => closeModal('extendCoolingPeriod')}
				title='Extend Cooling Period'
			>
				<FormControl variant='outlined' className={styles.textfield}>
					<InputLabel htmlFor='duration'>Duration</InputLabel>
					<OutlinedInput
						id='duration'
						className={styles.duration}
						name='duration'
						value={durationAdd}
						labelWidth={100}
						onChange={handleChange}
						inputProps={{
							autoComplete: 'off',
						}}
						startAdornment={
							<div>
								<CustomButton
									width={38}
									height={37}
									onClick={handleSubtract}
									disabled={durationAdd === 0 && true}
								>
									-
								</CustomButton>
							</div>
						}
						type='number'
						endAdornment={
							<div>
								<CustomButton
									width={38}
									height={37}
									onClick={handlePlus}
								>
									+
								</CustomButton>
							</div>
						}
					/>
					{/* <FormHelperText>{priceAddSubtractErrMsg}</FormHelperText> */}
				</FormControl>
				<div className={styles.btnWrapper}>
					<CustomButton
						width={166}
						height={42}
						onClick={handleUpdate}
					>
						Update
					</CustomButton>
				</div>
			</Modal>
		</div>
	);
};

export default connect(null, { closeModal, openModal })(ExtendCoolingModal);
